module.exports = __webpack_public_path__ + "img/detail-divider.ce607c8e.svg";